"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHECK_IN_REQUEST_EXAMPLES = exports.completeAppointmentRequestSchema = exports.noShowRequestSchema = exports.lateArrivalRequestSchema = exports.patientCheckInRequestSchema = exports.patientArrivalRequestSchema = void 0;
/**
 * Request contracts for the 5 Check-In endpoints. Field shapes mirror
 * `CheckInApplicationService`'s own method input shapes (backend,
 * frozen, Stage 5B.4).
 */
const zod_1 = require("zod");
exports.patientArrivalRequestSchema = zod_1.z.object({
    patientId: zod_1.z.string().uuid(),
    branchId: zod_1.z.string().uuid(),
    departmentId: zod_1.z.string().uuid(),
    visitTypeId: zod_1.z.string().uuid(),
    doctorId: zod_1.z.string().uuid().optional(),
    appointmentId: zod_1.z.string().uuid().optional(),
    priorityTier: zod_1.z.number().int(),
});
exports.patientCheckInRequestSchema = zod_1.z.object({
    appointmentId: zod_1.z.string().uuid(),
    fallbackVisitTypeId: zod_1.z.string().uuid().optional(),
});
exports.lateArrivalRequestSchema = zod_1.z.object({
    appointmentId: zod_1.z.string().uuid(),
    fallbackVisitTypeId: zod_1.z.string().uuid().optional(),
    graceMinutes: zod_1.z.number().int().positive().optional(),
    asOf: zod_1.z.coerce.date().optional(),
});
exports.noShowRequestSchema = zod_1.z.object({
    appointmentId: zod_1.z.string().uuid(),
    reasonDescription: zod_1.z.string().optional(),
});
exports.completeAppointmentRequestSchema = zod_1.z.object({
    appointmentId: zod_1.z.string().uuid(),
});
const UUID = '10000000-0000-0000-0000-000000000001';
exports.CHECK_IN_REQUEST_EXAMPLES = {
    patientArrival: {
        patientId: '11111111-1111-1111-1111-111111111111',
        branchId: '33333333-3333-3333-3333-333333333333',
        departmentId: '44444444-4444-4444-4444-444444444444',
        visitTypeId: '66666666-6666-6666-6666-666666666666',
        priorityTier: 0,
    },
    patientCheckIn: { appointmentId: UUID },
    lateArrival: { appointmentId: UUID, graceMinutes: 15 },
    noShow: { appointmentId: UUID },
    completeAppointment: { appointmentId: UUID },
};
//# sourceMappingURL=check-in.request.js.map